<div class="col-xs-12 col-sm-4 col-md-3">
	<div id="info-container" class="card-box clearfix scroll-box">
		<h5 class="heading long">{{{COLUMN_DATA this "#_name" undefined}}}</h5>
		{{#unless loaded}}
		<i class="fa fa-spin fa-spinner"></i>
		{{/unless}}
		<dl>
			{{#unless this.displayData}}
			<dt>{{TR "--"}}</dt>
			{{/unless}}
			{{#each this.displayData}}
				<dt>{{TR_DATAPOINT_CATEGORY ../category name}}</dt>
				<dd >{{value}} {{unit}}</dd>
			{{/each}}
		</dl>
	</div>
</div>
